module.exports = __webpack_public_path__ + "img/mind_link_icon.802586a8.png";